var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M50.3424 31.8685C50.3424 37.2622 48.3874 42.2031 45.153 46.0161H11.7519C8.50951 42.2031 6.5625 37.2622 6.5625 31.8685C6.5625 19.7784 16.3611 9.98401 28.4564 9.98401C40.5438 9.98401 50.3424 19.7784 50.3424 31.8685Z",
    fill: "#E8ECF3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4215 25.0192V42.158C46.4215 44.2934 44.6881 46.016 42.5571 46.016H14.4406C12.3096 46.016 10.5762 44.2855 10.5762 42.158V21.4787C10.5762 19.4068 12.2539 17.7318 14.3293 17.7318H20.3963C21.3823 17.7318 22.3285 18.1446 23.0044 18.8591L24.6821 20.6452C24.9922 20.9706 25.4137 21.1532 25.8669 21.1532H42.5491C43.5431 21.1532 44.4496 21.5263 45.1334 22.1455C45.7536 22.7012 46.1909 23.4633 46.35 24.3127C46.3977 24.5429 46.4215 24.781 46.4215 25.0192Z",
    fill: "white",
    stroke: "#010237",
    strokeWidth: 0.656442,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9879 33.7875C46.0349 33.7875 49.3157 30.5067 49.3157 26.4597C49.3157 22.4127 46.0349 19.132 41.9879 19.132C37.9409 19.132 34.6602 22.4127 34.6602 26.4597C34.6602 30.5067 37.9409 33.7875 41.9879 33.7875Z",
    fill: "#3B54EC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4229 25.8076L41.2686 25.8076C41.3205 25.8076 41.365 25.851 41.365 25.9016L41.365 30.053C41.365 30.1036 41.4095 30.147 41.4614 30.147L42.6918 30.147C42.7437 30.147 42.7882 30.1036 42.7882 30.053L42.7882 25.9016C42.7882 25.851 42.8327 25.8076 42.8846 25.8076L44.7329 25.8076C44.8218 25.8076 44.8663 25.7064 44.807 25.6485C43.9058 24.7692 43.0233 23.8417 42.1456 22.893C42.1086 22.8568 42.0419 22.8568 42.0048 22.893L39.3488 25.6485C39.2969 25.7064 39.3414 25.8076 39.4229 25.8076Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.115 46.0161H45.0721H11.6999H4.97461",
    stroke: "#010237",
    strokeWidth: 0.656442,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.bda4008260793f3b7ae9e1814ec301a1.svg";
export { ForwardRef as ReactComponent };